import axios from "axios";
import config from "../config";

const getAppointmentSearchApi = async (params) => {
  const response = await axios({
    url: `${config.api.base_url}book-appointment/${params.id}`,
    method: "get",
    params: params,
    headers: {
      "Content-Type": "application/json",
    },
  });

  return response;
};

export default getAppointmentSearchApi;
